import { render, staticRenderFns } from "./OrderNotificationType.vue?vue&type=template&id=4c96828c&scoped=true"
import script from "./OrderNotificationType.vue?vue&type=script&lang=js"
export * from "./OrderNotificationType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c96828c",
  null
  
)

export default component.exports